/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TranslationGroupType {
    UserEventMessages = 'UserEventMessages',
    UserEventCreatedByTypeMessages = 'UserEventCreatedByTypeMessages'
}


export function instanceOfTranslationGroupType(value: any): boolean {
    for (const key in TranslationGroupType) {
        if (Object.prototype.hasOwnProperty.call(TranslationGroupType, key)) {
            if (TranslationGroupType[key as keyof typeof TranslationGroupType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TranslationGroupTypeFromJSON(json: any): TranslationGroupType {
    return TranslationGroupTypeFromJSONTyped(json, false);
}

export function TranslationGroupTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationGroupType {
    return json as TranslationGroupType;
}

export function TranslationGroupTypeToJSON(value?: TranslationGroupType | null): any {
    return value as any;
}

export function TranslationGroupTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TranslationGroupType {
    return value as TranslationGroupType;
}

